import React from "react";
import "../../css/Subsidies/ParticipantSubsidyDetails.css";
import getParticipantStatusStyle from "../../utils/getParticipantStatusStyle";

const formatDate = (iso) =>
  new Date(iso).toLocaleString("pl-PL", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

const ParticipantSubsidyDetail = ({ participant, reservationStatus, onEdit }) => {
  const { label, icon, statusClass, strikeThrough } = getParticipantStatusStyle(participant.status);

  const isEligibleParticipant = [1, 2, 3].includes(participant.status);
  const canGrantSubsidy =
    [3, 4].includes(reservationStatus) && isEligibleParticipant;

  const showConfirmedWarning = reservationStatus === 3;

  return (
    <div className="participant-subsidy-card">
      <div className="participant-subsidy-left">
        <div className={`participant-subsidy-name ${statusClass}`}>
          <i className={`fa-solid ${icon}`} style={{ marginRight: "6px" }}></i>
          <span className={strikeThrough ? "strikethrough" : ""}>{participant.name}</span>
        </div>

        <div className="participant-subsidy-row">
          <span>Status:</span>
          <span>{label}</span>
        </div>

        <div className="participant-subsidy-row">
          <span>Koszt:</span>
          <span>
            {participant.baseCost?.toFixed(2)} zł{" "}
            {participant.subsidy != null && (
              <span style={{ color: "blue", fontWeight: "bold" }}>
                ({participant.realCost?.toFixed(2)} zł)
              </span>
            )}
          </span>
        </div>

        <div className="participant-subsidy-row">
          <span>Zaliczka:</span>
          <span>
            {participant.prepayment?.toFixed(2)} zł{" "}
            {participant.subsidy != null && (
              <span style={{ color: "blue", fontWeight: "bold" }}>
                ({participant.realPrepayment?.toFixed(2)} zł)
              </span>
            )}
          </span>
        </div>
      </div>

      <div className="participant-subsidy-right">
        {participant.subsidy != null ? (
          <>
            <div className="participant-subsidy-name">Dofinansowanie</div>

            <div className="participant-subsidy-row">
              <span>Procent:</span>
              <span>{participant.subsidyPercentage}%</span>
            </div>

            <div className="participant-subsidy-row">
              <span>Przyznano:</span>
              <span style={{ color: "blue", fontWeight: "bold" }}>
                {participant.subsidy?.toFixed(2)} zł
              </span>
            </div>

            <div className="participant-subsidy-row">
              <span>Przyznałx:</span>
              <span>{participant.grantedBy}</span>
            </div>

            <div className="participant-subsidy-row">
              <span>Data:</span>
              <span>{formatDate(participant.grantedAt)}</span>
            </div>
          </>
        ) : (
          <div className="participant-no-subsidy">
            {!canGrantSubsidy ? (
              <div className="participant-subsidy-info">
                Rezerwacja nie ma statusu oczekującego na zaliczkę ani potwierdzonego, więc nie można przyznać dofinansowania.
              </div>
            ) : (
              <>
                {showConfirmedWarning && (
                  <div className="participant-subsidy-info">
                    Uwaga: Rezerwacja posiada status POTWIERDZONA, więc została już wcześniej opłacona zaliczką lub jest bezkosztowa. Upewnij się, że spełnione są warunki przyznania dofinansowania.
                  </div>
                )}

                <div className="participant-subsidy-add-button" onClick={onEdit}>
                  Przyznaj dofinansowanie
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ParticipantSubsidyDetail;
